import { BIBLE_VERSE_COUNTS } from './verseCounts';

// For each outline item that has no end ref, infer it from the next sibling's start ref.
export function inferEndRefs(items) {
  if (!items.length) return items;
  const bookAbbr = items[0].book_abbr;
  const counts = BIBLE_VERSE_COUNTS[bookAbbr] || [];
  const lastVerseOf = ch => counts[ch - 1] || 0;

  return items.map((item, i) => {
    if (item.end_chapter && item.end_verse) return item;
    if (!item.start_chapter || !item.start_verse) return item;

    // Find the next item at the same or shallower level
    let next = null;
    for (let j = i + 1; j < items.length; j++) {
      if (items[j].level <= item.level) { next = items[j]; break; }
    }

    let ec = null, ev = null;
    if (next?.start_chapter) {
      const nc = next.start_chapter, nv = next.start_verse || 1;
      if (nv > 1) {
        ec = nc; ev = nv - 1;
      } else if (nc > 1) {
        const lv = lastVerseOf(nc - 1);
        if (lv) { ec = nc - 1; ev = lv; }
      }
    } else if (counts.length) {
      // Last top-level item — end at the book's last verse
      ec = counts.length;
      ev = counts[counts.length - 1];
    }

    return (ec && ev) ? { ...item, end_chapter: ec, end_verse: ev } : item;
  });
}

export function buildOutlineTree(items) {
  // items should already be end-ref-enriched (via inferEndRefs)
  const root = { children: [], level: 0 };
  const stack = [root];
  for (const item of items) {
    while (stack.length > 1 && stack[stack.length - 1].level >= item.level) stack.pop();
    const node = { ...item, children: [] };
    stack[stack.length - 1].children.push(node);
    stack.push(node);
  }
  return root.children;
}

export function formatOutlineRange(item) {
  if (!item.start_chapter || !item.start_verse) return '';
  const s = `${item.start_chapter}:${item.start_verse}`;
  if (!item.end_chapter || !item.end_verse) return s;
  if (item.start_chapter === item.end_chapter && item.start_verse === item.end_verse) return s;
  const e = item.end_chapter === item.start_chapter ? `${item.end_verse}` : `${item.end_chapter}:${item.end_verse}`;
  return `${s}—${e}`;
}

// Build verse→[outlineItems] map; items with no start_verse slot in at verse 1
export function buildOutlinesByVerse(outlines) {
  const map = {};
  for (const ol of outlines) {
    const v = ol.start_verse || 1;
    if (!map[v]) map[v] = [];
    map[v].push(ol);
  }
  return map;
}
